import { getElementByQuery } from '../../js/utilities/utilities.element';
export function handleLiveStreamNoDvr(player, streamObject) {
    const isLiveStreamNoDvr = streamObject.stream.isLiveStream && streamObject.stream.hasDvrWindow === false;
    const playerElement = getElementByQuery({ container: player.getContainer(), query: '.bmpui-npo-player' });
    const noDvrClass = 'livestream-no-dvr';
    playerElement?.classList[isLiveStreamNoDvr ? 'add' : 'remove'](noDvrClass);
}
